import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import {
    Grid,
} from '@material-ui/core'

import OperatorCard from '../OperatorCard/OperatorCard.js'

const useStyles = makeStyles((theme) => ({
    root: { marginTop: theme.spacing(3) },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        marginBottom: theme.spacing(2),
    },
    title: {
        position: 'relative',
        '&:after': {
            position: 'absolute',
            bottom: -8,
            left: 0,
            content: '" "',
            height: 3,
            width: 48,
            backgroundColor: theme.palette.primary.main,
        },
    },
    actions: {
        display: 'flex',
        alignItems: 'center',
    },
    gridList: {
        overflowY: 'scroll',
        maxHeight: '75vh'
    }
}))

const Projects = (props) => {
    const { className, operators, deleteOperator, navigateDetails, ...rest } = props

    const classes = useStyles()

    useEffect(() => {
        let mounted = true

        return () => {
            mounted = false
        }
    }, [])

    return (
        <div {...rest} className={clsx(classes.root, className)}>
            <Grid container spacing={3} className={classes.gridList}>
                {operators.map((operator) => (
                    <Grid
                        item
                        key={operator.id}
                        md={4}
                        sm={6}
                        xs={12}>
                        <OperatorCard operator={operator} deleteOperator={deleteOperator} navigateDetails={navigateDetails}/>
                    </Grid>
                ))}
            </Grid>
        </div>
    )
}

Projects.propTypes = {
    className: PropTypes.string,
}

export default Projects
